import { jsx as f, jsxs as p, Fragment as ee } from "../../_virtual/jsx-runtime.mjs";
import * as t from "react";
import { u as te, e as ne, w as oe } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import q from "./CommonVideo.mjs";
import { PauseIcon as ce, ReplayIcon as se, PlayIcon as le } from "./Icon.mjs";
import { videoBtn as ae } from "./css/Media.css.mjs";
import M from "../../depend/classnames/index.mjs";
import { DEFAULT_SCREEN_BREAKPOINT as G, isPcSameM as re } from "./const.mjs";
import ie from "./hooks/useShowControl.mjs";
const ue = (e, k) => {
  switch (k.type) {
    case "play":
    case "replay":
      return "playing";
    case "pause":
      return "paused";
    case "done":
      return "done";
  }
}, me = t.forwardRef((e, k) => {
  var V, A, x, z, _, j, D, F, L, H, K, O, U, W;
  const J = e.breakpoint ?? G, { showAboveBreakpoint: Q, showBelowBreakpoint: X, styleNode: Y } = ie(J), v = t.useMemo(() => {
    var s;
    const o = (s = e.video) == null ? void 0 : s.m;
    return re(o);
  }, [e]), c = t.useMemo(() => {
    var o, s, u, m, d, y;
    return {
      autoplay: (s = (o = e.video) == null ? void 0 : o.pc) == null ? void 0 : s.autoplay,
      loop: (m = (u = e.video) == null ? void 0 : u.pc) == null ? void 0 : m.loop,
      controls: (y = (d = e.video) == null ? void 0 : d.pc) == null ? void 0 : y.controls
    };
  }, [(A = (V = e.video) == null ? void 0 : V.pc) == null ? void 0 : A.autoplay, (z = (x = e.video) == null ? void 0 : x.pc) == null ? void 0 : z.controls, (j = (_ = e.video) == null ? void 0 : _.pc) == null ? void 0 : j.loop]), g = te(), w = t.useMemo(() => g < (e.breakpoint ?? G), [e.breakpoint, g]), [r, R] = t.useReducer(ue, c.autoplay ? "playing" : "paused"), i = t.useRef(null), h = t.useRef(null), [n, Z] = t.useState({ current: null }), a = t.useCallback(() => {
    var u, m, d, y;
    const o = ((u = n.current) == null ? void 0 : u.currentTime) && ((m = n.current) == null ? void 0 : m.currentTime) > 0 && !((d = n.current) != null && d.paused) && !((y = n.current) != null && y.ended), s = () => {
      var $;
      ($ = n.current) == null || $.play().then(() => {
        var S;
        R({ type: "play" }), (S = n.current) == null || S.removeEventListener("canplay", s);
      }, (S) => {
        console.error(S);
      });
    };
    n.current && !o && s();
  }, [n]), l = t.useCallback(() => {
    n.current && (n.current.pause(), R({ type: "pause" }));
  }, [n]);
  t.useEffect(() => {
    const o = w ? v ? i : h : i;
    Z((s) => (s !== o && (i.current && (i.current.currentTime = 0), h.current && (h.current.currentTime = 0), l()), o));
  }, [l, w, v]), t.useImperativeHandle(k, () => ({
    el: n.current,
    play: a,
    pause: l
  }), [l, a, n]);
  const B = t.useCallback(() => {
    c.loop || R({ type: "done" });
  }, [c.loop]), b = t.useCallback(() => {
    r === "playing" ? l() : a();
  }, [l, a, r]), C = t.useMemo(() => e.videoBtnSize ?? "large", [e.videoBtnSize]), N = t.useMemo(
    () => M(
      ae[e.videoBtnType ?? "bigVideo"],
      e.btnClassName
    ),
    [e.btnClassName, e.videoBtnType]
  ), E = t.useMemo(() => r === "playing" ? /* @__PURE__ */ f(
    ce,
    {
      className: N,
      style: e.btnStyle,
      size: C,
      onClick: b
    }
  ) : r === "done" ? /* @__PURE__ */ f(
    se,
    {
      className: N,
      style: e.btnStyle,
      size: C,
      onClick: b
    }
  ) : /* @__PURE__ */ f(
    le,
    {
      className: N,
      style: e.btnStyle,
      size: C,
      onClick: b
    }
  ), [N, b, e.btnStyle, C, r]), T = t.useMemo(
    () => c.controls ? null : E,
    [E, c.controls]
  ), P = t.useMemo(
    () => ({
      commonClassName: e.commonClassName,
      commonStyle: e.commonStyle,
      style: e.style,
      onEnded: B,
      loop: c.loop ?? !1,
      icon: T,
      controls: c.controls ?? !1,
      children: e.children
    }),
    [
      e.commonClassName,
      e.commonStyle,
      e.style,
      e.children,
      B,
      c.loop,
      c.controls,
      T
    ]
  ), I = ne(n, e.threshold);
  return t.useEffect(() => {
    const o = n.current;
    c.autoplay && o && (I ? a() : (l(), o.currentTime = 0));
  }, [l, a, I, c.autoplay, n]), /* @__PURE__ */ p(ee, { children: [
    Y,
    /* @__PURE__ */ f(
      q,
      {
        ref: i,
        ...P,
        className: M(e.className, { [Q]: !v }),
        poster: (F = (D = e.video) == null ? void 0 : D.pc) == null ? void 0 : F.poster,
        src: (H = (L = e.video) == null ? void 0 : L.pc) == null ? void 0 : H.src,
        style: e.style
      }
    ),
    v ? null : /* @__PURE__ */ f(
      q,
      {
        ref: h,
        ...P,
        className: M(e.className, X),
        poster: (O = (K = e.video) == null ? void 0 : K.m) == null ? void 0 : O.poster,
        src: (W = (U = e.video) == null ? void 0 : U.m) == null ? void 0 : W.src,
        style: e.style
      }
    )
  ] });
}), Se = oe(me, {});
export {
  Se as default
};
//# sourceMappingURL=Video.mjs.map
